"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="flex gap-1">
        <div className="h-9 w-16 bg-primary-light animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-primary-light animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-primary-light animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {/* Desktop Menu */}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map(item => {
          const linkTo = item.label === "Autobuses" ? "#buses" : item.href || "#";
          return <NavigationMenuItem key={item.id}>
                <NavigationMenuLink asChild>
                  <Link to={linkTo} className="inline-flex items-center justify-center h-9 px-4 py-2 text-sm font-medium text-foreground">
                    {item.label}
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>;
        })}
        </NavigationMenuList>
      </NavigationMenu>

      {/* Botón móvil */}
      <Button variant="ghost" size="icon" className="md:hidden text-foreground" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {/* MENÚ MÓVIL */}
      {mobileMenuOpen && <div className="fixed top-0 left-0 w-full h-screen z-[9999] bg-white flex flex-col" style={{
      animation: "slideDown 0.35s ease-out"
    }}>
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-primary/20">
            <span className="font-display text-lg text-foreground italic">
              Donde acaba el mar y empieza nuestra historia
            </span>

            <Button variant="ghost" size="icon" onClick={() => setMobileMenuOpen(false)}>
              <X className="size-6" />
            </Button>
          </div>

          {/* Links */}
          <nav className="flex flex-col p-4 gap-2">
            {menuItems.map(item => {
          const linkTo = item.label === "Autobuses" ? "#buses" : item.href || "#";
          return <Link key={item.id} to={linkTo} className="px-4 py-3 text-base font-medium text-foreground rounded-md hover:bg-primary/10" onClick={() => setMobileMenuOpen(false)}>
                  {item.label}
                </Link>;
        })}
          </nav>
        </div>}
    </>;
}
export default function Encabezado() {
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (!anchor) return;
      const href = anchor.getAttribute("href");
      if (!href) return;
      if (href === "/#") {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
        return;
      }
      let hash = "";
      if (href.startsWith("#")) {
        hash = href;
      } else if (href.includes("#")) {
        const [, hashPart] = href.split("#");
        hash = "#" + hashPart;
      }
      if (hash && hash !== "#") {
        const element = document.querySelector(hash);
        if (element) {
          e.preventDefault();
          element.scrollIntoView({
            behavior: "smooth"
          });
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className="sticky top-0 z-50 w-full bg-background/80 backdrop-blur-md">
      <div className="container flex justify-center h-16">
        <MenuProvider menu_id="3">
          <HeaderMenuConsumer />
        </MenuProvider>
      </div>
    </header>;
}